import React from 'react'
import {
  DcButton,
  DcDiv,
  DcInput,
  DcInputTag,
  DcText,
  PixelFactoryContext,
} from 'pixel-base'
import styled from 'styled-components'

import { post, put } from 'utils/api-routes.util'

import { IWarehouseDetail } from './WarehouseDetails'
import { IPixelFactory } from '../../../../../../decl.d'
import PlusIcon from '../../../../../utils/icons/plus-icon'
import SaveIcon from '../../../../../utils/icons/save-icon'

const WarehouseForm = (props) => {
  const { handleClose, warehouse, warehouseId, zonesList } = props
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [data, setData] = React.useState<IWarehouseDetail>({
    name: '',
    warehouse_code: '',
    description: '',
    address: '',
    zones: [],
    phone: '',
    city: '',
  })

  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    showPageLoader()
    const zoneData = {
      name: data.name,
      warehouse_code: data.warehouse_code,
      description: data.description,
      address: data.address,
      zone_ids: data.zones?.map((zone) => Number(zone.id)),
      phone: data.phone,
      city: data.city,
    }
    const req =
      warehouseId !== null
        ? put(`/warehouses/${warehouseId}`, zoneData)
        : post('/warehouses', zoneData)
    req.subscribe((res: any) => {
      if (res.response.data) {
        showSuccess('Successfully Added')
        setData({
          name: res.response.data.name,
          warehouse_code: res.response.data.warehouse_code,
          description: res.response.data.description,
          address: res.response.data.address,
          zones: res.response.data.zones,
          phone: res.response.data.phone,
          city: res.response.data.city,
        })
        handleClose(res.response.data, warehouseId !== null ? 'update' : 'add')
        hidePageLoader()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
        hidePageLoader()
      }
    })
  }

  React.useEffect(() => {
    if (warehouseId !== null) {
      setData({
        ...data,
        name: warehouse.name,
        warehouse_code: warehouse?.warehouse_code,
        description: warehouse?.description,
        address: warehouse?.address,
        zones: warehouse?.zones,
        phone: warehouse?.phone,
        city: warehouse?.city,
      })
    } else {
      setData({
        ...data,
        name: '',
        warehouse_code: '',
        description: '',
        address: '',
        zones: [],
      })
    }
  }, [warehouse, warehouseId])

  const disableWarehouseEdit = () => {
    let isOneLogisticsMapped = false
    warehouse?.couriers?.forEach((courier) => {
      if (courier.courier_name === 'One Logistics') {
        isOneLogisticsMapped = true
      }
    })
    return isOneLogisticsMapped
  }

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Warehouse Name
            </DcText>
            <DcInput
              error={
                error.field === 'name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Warehouse Name'}
              placeholder={'Warehouse Name'}
              value={data.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />{' '}
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Warehouse Code
            </DcText>
            <DcInput
              error={
                error.field === 'warehouse_code' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Warehouse Code'}
              placeholder={'Warehouse Code'}
              value={data.warehouse_code}
              onChange={(e) =>
                setData({ ...data, warehouse_code: e.target.value })
              }
            />
          </DcDiv>
        </FormGroup>
        <FormGroup>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              City
            </DcText>
            <DcInput
              error={
                error.field === 'city' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'City'}
              placeholder={'City'}
              value={data.city}
              onChange={(e) => setData({ ...data, city: e.target.value })}
              disabled={disableWarehouseEdit()}
            />{' '}
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Phone Number
            </DcText>
            <DcInput
              error={
                error.field === 'phone' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Phone Number'}
              placeholder={'Phone Number'}
              value={data.phone}
              onChange={(e) => setData({ ...data, phone: e.target.value })}
            />
          </DcDiv>
        </FormGroup>
        <FormGroup>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Description
            </DcText>
            <DcInput
              error={
                error.field === 'description' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Description'}
              placeholder={'Description'}
              value={data.description}
              onChange={(e) =>
                setData({ ...data, description: e.target.value })
              }
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Add Zone
            </DcText>
            <DcInputTag
              error={
                error.field === 'zone_ids' && error.error !== ''
                  ? error.error
                  : null
              }
              allowCustomTags={false}
              placeholder="Add Zone"
              showAddButton
              handleTagDelete={(tag) => {
                setData({
                  ...data,
                  zones: data.zones.filter((item) => item.id != tag.value),
                })
              }}
              options={zonesList?.map((item) => {
                return {
                  label: item.zone_name,
                  value: item.id ?? item.zone_id,
                }
              })}
              onTagUpdate={(newTags) => {
                setData({
                  ...data,
                  zones: newTags.map((t) => ({
                    id: Number(t.value),
                    zone_name: t.label,
                  })),
                })
              }}
              clearAll={() => {
                setData({
                  ...data,
                  zones: [],
                })
              }}
              handleTagAdd={(e) => {
                setData({
                  ...data,
                  zones: [
                    ...data.zones,
                    {
                      id: Number(e.value),
                      zone_name: e.label,
                    },
                  ],
                })
              }}
              tags={data.zones?.map((item) => {
                return {
                  label:
                    zonesList?.find(
                      (city) => (city.id ?? city.zone_id) == item.id,
                    )?.zone_name ||
                    item.zone_name ||
                    item,
                  value: item.id,
                }
              })}
            />
          </DcDiv>
        </FormGroup>
        <FormGroup>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Warehouse Address
            </DcText>
            <DcInput
              error={
                error.field === 'address' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              as={'textarea'}
              name={'Warehouse Address'}
              placeholder={'Warehouse Address'}
              value={data.address}
              onChange={(e) => setData({ ...data, address: e.target.value })}
              disabled={disableWarehouseEdit()}
            />
          </DcDiv>
        </FormGroup>
        {disableWarehouseEdit() && (
          <DcText customColor="red" fontSize="12px">
            You can not edit <strong>City</strong> and{' '}
            <strong>Warehouse Address</strong> fields if warehouse is mapped on
            One Logistics
          </DcText>
        )}
        <FormGroup flexEnd>
          <DcButton variant="primary" size="sm" type="submit" withIcon={true}>
            {warehouseId ? <SaveIcon size={16} /> : <PlusIcon size={16} />}
            <span>{warehouseId ? 'Update' : 'Add'}</span>
          </DcButton>
        </FormGroup>
      </Form>
    </>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

export default WarehouseForm
